import _ from 'lodash'
import SLIDER_HOME_BUSINESS_CONFIG from './config'
import Flickity from 'flickity-fade'
import gsap from 'gsap'
import imagesLoaded from 'imagesloaded'

class SliderHomeBusinessClass {
    constructor() {
        this.DOM = {
            section: SLIDER_HOME_BUSINESS_CONFIG.section,
            slider: SLIDER_HOME_BUSINESS_CONFIG.slider,
            slides: SLIDER_HOME_BUSINESS_CONFIG.slides,
            navs: Array.from( SLIDER_HOME_BUSINESS_CONFIG.navs ),
            bars: SLIDER_HOME_BUSINESS_CONFIG.bars
        }

        this.autoPlay = SLIDER_HOME_BUSINESS_CONFIG.autoPlay
        this.flckty = null
        this.index = 0
        this.controls = []

        this.DOM.section ? this.init() : null
    }

    init() {
        this._timelines()
        this._flckty()
        this._listeners()
    }

    _listeners() {
        this.DOM.navs.forEach( ( nav ) => { nav.addEventListener( 'click', this._nav.bind( this ) ) })
    }

    _flckty() {
        imagesLoaded( this.DOM.section, () => {
            this.flckty = new Flickity( this.DOM.slider, {
                prevNextButtons: false,
                pageDots: false,
                fade: true,
                autoPlay: this.autoPlay,
                pauseAutoPlayOnHover: false,
                on: {
                    ready: () => {
                        this._change( 0 )
                    },
                    change: ( index ) => {
                        this._change( index )
                    }
                }
            })
        })
    }

    _timelines() {
        this.DOM.bars.forEach( ( control ) => {
            let tl = gsap.timeline( { paused: true })
            tl.to( control, {
                width: '100%',
                duration: 5
            })
            this.controls.push( tl )
        })
    }

    _change( index ) {
        this.controls[ this.index ].pause().progress(0)
        this.controls[ index ].play()

        this.index = index
    }

    _nav() {
        let index = this.DOM.navs.indexOf( event.target )
        this.flckty.select( index )
    }
}

const SLIDER_HOME_BUSINESS = new SliderHomeBusinessClass()
export default SLIDER_HOME_BUSINESS